// extracted by mini-css-extract-plugin
export default {"container":"_2wmuvhRxGiJdPp75Inw6Qn","video":"_2vI1dX37DnkJYV7Z4pWVnT","title":"_1D4j0PcP_A6t1s2fd7J3X7"};